import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { App } from './App.tsx';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('index.html has no #root to mount into');

// The server sends the prerendered landing only to a browser without a session cookie.
const app = (
  <StrictMode>
    <App signedOut={'signedOut' in root.dataset} />
  </StrictMode>
);
if (root.hasChildNodes()) hydrateRoot(root, app);
else createRoot(root).render(app);
